import { observer } from 'mobx-react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';

import type React from 'react';
import { FlagMeasurementRow } from '@/components/boxes/measurementBoxes/FlagMeasurementBox/FlagMeasurementRow.tsx';

export interface FlagMeasurementProps {
  label: string;
  descriptor: string;
  details: unknown;
}

interface FlagMeasurementBoxProps {
  measurements: Array<FlagMeasurementProps>;
  hasCriteria: boolean | undefined;
}

export const FlagMeasurementBox: React.FC<FlagMeasurementBoxProps> = observer(
  ({ measurements, hasCriteria }: FlagMeasurementBoxProps) => {
    return (
      <TableContainer component={Paper}>
        <Table aria-label="a dense table" size="small">
          <TableBody>
            {measurements.map((measurement: FlagMeasurementProps, index: number) => (
              <FlagMeasurementRow key={index} measurement={measurement} hasCriteria={hasCriteria} index={index} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
);
